import { get } from '@/admin/services/api/http-utils';

const url = `${process.env.VUE_APP_API_HOST}admin/delivery`;

function fetchNSDelivery() {
  return get(`${url}?byCustomer=true&paymentTypes[]=НС`);
}

export default {
  fetchDebtByTourId: fetchNSDelivery,
};
